export const MESSAGE_TYPE = 'SHIPPING_RESTRICTION_WARNING_MESSAGE';
export const DONOT_SHOW_PO_NOTIFICATION = 'doNotShowPONotification';
